module.exports = __webpack_public_path__ + "static/media/image10.6b1ad7a6.jpeg";